module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/mlb/new_survive-dc1c7696479a721094033dc099af18bf.svg";